import { Link } from "react-router-dom"
import { Row, Col, ListGroup, Image, Form, Button, Card } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { FaTrash } from "react-icons/fa"
import Message from "../components/Message"
import { addToCart, removeFromCart } from "../slices/cartSlice"

const CartScreen = () => {
  const dispatch = useDispatch();

  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;

  const addToCartHandler = async (product, quantity, selectedPriceCustomization, selectedSpiceLevel, selectedSweetness) => {
    dispatch(addToCart({...product, quantity, selectedPriceCustomization, selectedSpiceLevel, selectedSweetness}))
  }

  const removeFromCartHandler = (item) => {
    dispatch(
      removeFromCart({
        _id: item._id,
        selectedPriceCustomization: item.selectedPriceCustomization,
        subCategory: item.subCategory,
        selectedSpiceLevel: item.selectedSpiceLevel,
        selectedSweetness: item.selectedSweetness,
      })
    );
  };

  const checkoutHandler = () => {
    //navigate('/login?redirect=/shipping')
    window.location.href = '/login?redirect=/shipping'
  }

  return (
    <Row>
        <Col md={8}>
            <Link className='btn btn-light mt-1 mb-3' to='/'>Back</Link>
            <h2 style={{marginBottom: '10px'}}>Shopping Cart</h2>
            { cartItems.length === 0 ? (
                <Message>
                    Your cart is empty <Link to="/">Go Back</Link>
                </Message>
            ) : (
                <ListGroup variant="flush">
                    {cartItems.map((item) => (
                        <ListGroup.Item key={item._id + "_" + item.customization.priceCustomization[item.selectedPriceCustomization].weight + "_" + ((item.subCategory === "Hot Snacks" && item.selectedSpiceLevel) || (item.subCategory === "Sweets" && item.selectedSweetness))}>
                            <Row>
                                <Col xs={4} sm={4} md={2}>
                                    <Image src={item.image} alt = {item.name} fluid rounded/>
                                </Col>
                                <Col xs={6} sm={6} md={8}>
                                    <Row>
                                        <span>
                                            <Link to={`/product/${item._id}`}>{item.name}</Link>{(item.subCategory === "Hot Snacks" && " - Spice Level: " + item.selectedSpiceLevel)  || (item.subCategory === "Sweets" && " - Sweetness: " +  item.selectedSweetness)}
                                        </span>
                                    </Row>
                                    <Row>
                                        <span>
                                            Weight: {item.customization.priceCustomization[item.selectedPriceCustomization].weight}
                                        </span>
                                    </Row>
                                    <Row>
                                        <span>
                                            Price: ₹{item.customization.priceCustomization[item.selectedPriceCustomization].price}
                                        </span>
                                    </Row>
                                </Col>
                                <Col sm={2} md={2}>
                                    <Row className="m-1">
                                        <Form.Control
                                            as='select'
                                            size="sm"
                                            value={item.quantity}
                                            onChange={(e) => addToCartHandler(item, Number(e.target.value), item.selectedPriceCustomization, item.selectedSpiceLevel, item.selectedSweetness)}>
                                            {[...Array(10).keys()].map((x) => (
                                                <option key={x + 1} value={x + 1}>
                                                    {x + 1}
                                                </option>
                                            ))}
                                        </Form.Control>
                                    </Row>
                                    <Row className="m-1">
                                        <Button type="button" variant="light" onClick={() => removeFromCartHandler(item)}>
                                            <FaTrash/>
                                        </Button>
                                    </Row>
                                </Col>
                            </Row>
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            ) }
        </Col>
        <Col md={4}>
            <Card className="h-auto">
                <ListGroup variant="flush">
                    <ListGroup.Item>
                        <h2>
                            Subtotal ({cartItems.reduce((acc, item) => acc + item.quantity, 0)}) items
                        </h2>
                        ₹{cartItems.reduce((acc, item) => acc + item.customization.priceCustomization[item.selectedPriceCustomization].price*item.quantity, 0).toFixed(2)}
                    </ListGroup.Item>
                    <ListGroup.Item>
                        <Button
                            type="button"
                            className="btn-block"
                            disabled={cartItems.length === 0}
                            onClick={checkoutHandler}>
                            Proceed to Checkout
                        </Button>
                    </ListGroup.Item>
                </ListGroup>
            </Card>
        </Col>
    </Row>
  )
}

export default CartScreen